import { FC } from "react";
import MaintenanceAlertsTableSection from "components/common/objects/MaintenanceAlerts/MaintenanceAlertsTableSection";

type Props = {
  accountId: string;
};

const AccountMaintenanceAlertsSection: FC<Props> = ({ accountId }) => (
  <MaintenanceAlertsTableSection accountId={accountId} variant="account" />
);

export default AccountMaintenanceAlertsSection;
